import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M15 4a5 5 0 0 0-5 5c0 .512.171 1.09.393 1.717a1 1 0 0 1-.188.989l.002.001-.035.035-.03.03L4 17.915V20h2.5v-1.5h2V16h2.25v-2h.005a1 1 0 0 1 1.496-.766C13 13.668 14.104 14 15 14a5 5 0 0 0 0-10Zm-2.25 11.62c.728.235 1.515.38 2.25.38a7 7 0 1 0-7-7c0 .63.144 1.25.306 1.78L2 17.086V22h6.5v-1.5h2V18h2.25v-2.38ZM14.5 7a1 1 0 0 1 1-1v1-1H15.538a1.507 1.507 0 0 1 .19.018c.107.015.244.044.4.096.318.106.707.307 1.08.679.371.372.572.761.678 1.078a2.301 2.301 0 0 1 .113.591v.02l.001.01v.006s0 .002-1 .002h1a1 1 0 0 1-1.999.05.366.366 0 0 0-.012-.046.77.77 0 0 0-.196-.297.77.77 0 0 0-.297-.196A.37.37 0 0 0 15.45 8 1 1 0 0 1 14.5 7Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
